import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Body2, Button, Link } from "@activecollab/components";
import PropTypes from "prop-types";
import Angie from "~/utils/angie.jsx";
import RescheduleInfoBox from "./RescheduleInfoBox.jsx";
import { RescheduleSimulationSplitContent } from "./RescheduleSimulationSplitContent.js";
import TaskTableRow from "./TaskTableRow.jsx";
import FormatDateRange from "../../Formatters/FormatDateRange.jsx";

export const RescheduleSimulationContent = ({ simulation, simulationChangedText, splitTask, onSubmit, onCancel }) => {
  const { t } = useTranslation();

  const number = simulation.length + (splitTask ? 1 : 0);
  const tasks = number > 1 ? t("tasks") : t("task");

  if (simulation.length === 0 && splitTask) {
    return (
      <RescheduleSimulationSplitContent
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    );
  }

  return (
    <>
      <div className="task_reschedule_modal_header">
        <h1>{t("Change the Date")}</h1>
      </div>
      <div className="task_reschedule_modal_divider" />
      <div className="task_reschedule_modal_body">
        <div className="task_reschedule">
          <RescheduleInfoBox text={simulationChangedText} />
          <p>
            <Trans>
              <b>
                {{ number }} {{ tasks }}
              </b>{" "}
              will be affected by this date change:
            </Trans>
          </p>
          {splitTask ? (
            <Body2 color="secondary">
              #{splitTask.task_number}: {splitTask.name}{" "}
              {t("will lose it's custom estimation splits because duration of the task changes.")}{" "}
              <Link
                href={`${Angie.activecollab_site_url}/help/books/activecollab-workload/split-estimates`}
                variant="text link-primary"
                className="tw-w-fit"
                target="_blank"
              >
                <Body2 color="theme-primary">{t("Learn More")}</Body2>
              </Link>
            </Body2>
          ) : null}
          {simulation ? (
            <Body2
              className="tw-mt-2"
              color="secondary"
            >
              {t("Due dates of succeeding tasks will be adjusted to match the new schedule:")}
            </Body2>
          ) : null}
          <table className="reschedule_table tw-mt-4">
            <thead>
              <tr>
                <th>{t("Name of the Task")}</th>
                <th>{t("Old Date")}</th>
                <th />
                <th>{t("New Date")}</th>
              </tr>
            </thead>
            <tbody>
              {simulation &&
                simulation.map((task) => {
                  const oldDate =
                    task.old && task.old.start_on && task.old.due_on ? (
                      <FormatDateRange
                        start={task.old.start_on}
                        end={task.old.due_on}
                      />
                    ) : (
                      t("No old date")
                    );
                  const newDate =
                    task.new && task.new.start_on && task.new.due_on ? (
                      <FormatDateRange
                        start={task.new.start_on}
                        end={task.new.due_on}
                      />
                    ) : (
                      t("No new date")
                    );
                  return (
                    <TaskTableRow
                      key={task.id}
                      taskNumber={task.task_number}
                      name={task.name}
                      oldDate={oldDate}
                      newDate={newDate}
                      isCompleted={task.is_completed}
                    />
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="task_reschedule_modal_divider" />
      <div className="task_reschedule_modal_buttons">
        <Button
          onClick={onSubmit}
          className="tw-mr-3"
          variant="primary"
          autoFocus
        >
          {t("Make the Change")}
        </Button>
        <Button
          variant="secondary"
          onClick={onCancel}
          data-action="cancel"
        >
          {t("Cancel")}
        </Button>
      </div>
    </>
  );
};

RescheduleSimulationContent.propTypes = {
  simulation: PropTypes.array,
  simulationChangedText: PropTypes.string,
  splitTask: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

RescheduleSimulationContent.defaultProps = {
  simulation: {},
  simulationChangedText: "",
};
